import React from 'react'
import cn from 'classnames'
import styles from './checkout-frame.scss'
import PropTypes from 'prop-types'

const CheckoutFrame = (props) => {
  return <main className={cn(styles['main-container'])}>
    <section className={styles['action-container']}>
      {props.left}
    </section>
    <section className={styles['description-container']}>
      {props.right}
    </section>
  </main>
}

CheckoutFrame.propTypes = {
  left: PropTypes.element,
  right: PropTypes.element
}

export default CheckoutFrame
